export const getEnvironmentFromHostname = () => {
  const host = window.location.hostname;
  if (/-local/.test(host)) {
    return 'local';
  }

  if (/-test/.test(host)) {
    return 'test';
  }
  if (/-dev/.test(host)) {
    return 'dev';
  }
  if (/-stg/.test(host)) {
    return 'stg';
  }
  if (/-local/.test(host) || /localhost/.test(host) || /^[0-9.]+$/.test(host)) {
    return 'dev'; // it is locale actually
  }
  return 'prod';
};

export const getBrowserType = () => {
  if (
    (navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR')) != -1
  ) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf('Edg') != -1) {
    return 'Edge';
  } else if (navigator.userAgent.indexOf('Chrome') != -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') != -1) {
    return 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') != -1) {
    return 'Firefox';
  } else if (
    navigator.userAgent.indexOf('MSIE') != -1 ||
    // @ts-ignore
    !!document?.documentMode
  ) {
    return 'IE';
  } else {
    return 'Unknown';
  }
};
